(() => {
  const ELEMENT_NAME = 'ct-whatsapp-proof-carousel';

  class CTWhatsAppProofCarousel extends HTMLElement {
    connectedCallback() {
      if (this.abortController) return;

      this.abortController = new AbortController();
      this.group = this.querySelector('[data-ct-wp-group]');
      this.track = this.querySelector('[data-ct-wp-track]');
      this.deferredTemplate = this.querySelector('[data-ct-wp-deferred]');
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.hydrated = false;

      if (!this.group || !this.track) return;

      const hydrateDistance = Math.max(0, Number.parseInt(this.dataset.hydrateDistance || '600', 10) || 0);

      if ('IntersectionObserver' in window && !window.Shopify?.designMode) {
        this.hydrationObserver = new IntersectionObserver(
          (entries) => {
            if (!entries.some((entry) => entry.isIntersecting)) return;
            this.hydrationObserver?.disconnect();
            this.hydrate();
          },
          { rootMargin: `${hydrateDistance}px 0px` }
        );
        this.hydrationObserver.observe(this);
      } else {
        this.hydrate();
      }

      if ('IntersectionObserver' in window) {
        this.visibilityObserver = new IntersectionObserver(
          (entries) => {
            this.classList.toggle('is-in-view', entries.some((entry) => entry.isIntersecting));
          },
          { threshold: 0.01 }
        );
        this.visibilityObserver.observe(this);
      } else {
        this.classList.add('is-in-view');
      }
    }

    disconnectedCallback() {
      this.abortController?.abort();
      this.querySelector('[data-ct-wp-duplicate]')?.remove();
      this.dataset.ready = 'false';
      this.hydrationObserver?.disconnect();
      this.visibilityObserver?.disconnect();
      this.abortController = null;
      this.hydrationObserver = null;
      this.visibilityObserver = null;
      this.group = null;
      this.track = null;
      this.deferredTemplate = null;
      this.reducedMotion = null;
      this.hydrated = false;
    }

    hydrate() {
      if (this.hydrated || !this.group || !this.track) return;
      this.hydrated = true;

      if (this.deferredTemplate) {
        const prototype = this.group.querySelector('[data-ct-wp-approved]');
        const urls = JSON.parse(this.deferredTemplate.textContent);
        const fragment = document.createDocumentFragment();
        for (const url of urls) {
          const card = prototype.cloneNode(true);
          card.removeAttribute('data-ct-wp-approved');
          const image = card.querySelector('img');
          const resize = url + (url.includes('?') ? '&width=' : '?width=');
          image.srcset = `${resize}240 240w, ${resize}360 360w, ${resize}480 480w, ${url} 600w`;
          image.src = url;
          fragment.appendChild(card);
        }
        this.group.appendChild(fragment);
        this.deferredTemplate.remove();
        this.deferredTemplate = null;
      }

      const cards = this.group.querySelectorAll('.ct-whatsapp-proof__card');
      if (cards.length < 2 || this.dataset.animate !== 'true') {
        this.dataset.ready = 'true';
        return;
      }

      const duplicate = this.group.cloneNode(true);
      duplicate.removeAttribute('data-ct-wp-group');
      duplicate.setAttribute('data-ct-wp-duplicate', '');
      duplicate.setAttribute('aria-hidden', 'true');
      duplicate.setAttribute('inert', '');
      duplicate.querySelectorAll('[data-shopify-editor-block]').forEach((element) => {
        element.removeAttribute('data-shopify-editor-block');
      });
      duplicate.querySelectorAll('img').forEach((image) => {
        image.alt = '';
      });
      this.track.appendChild(duplicate);

      requestAnimationFrame(() => {
        this.dataset.ready = 'true';
      });
    }
  }

  if (!customElements.get(ELEMENT_NAME)) {
    customElements.define(ELEMENT_NAME, CTWhatsAppProofCarousel);
  }
})();

